export const style = {
  row: {
    cursor: 'pointer',
  },
  fw: {
    fontWeight: 500,
  },
  Typography: {
    sx: {
      fontWeight: 500,
    },
  },
  IconButton: {
    sx: {
      border: 1,
      borderColor: 'divider',
    },
  },
  tableCell: {
    arrowCell: {
      width: 20,
    },
    runDateCell: {
      width: 160,
    },
    statusCell: {
      width: 180,
    },
    idCell: {
      width: 128,
    },
    runTimeCell: {
      width: 148,
    },
  },
} as const;
